import { observer } from 'mobx-react';
import Picker from '~/view/components/Controls/Pickers/Picker/Picker';
import { IPickerOption, PickerType } from '~/view/components/Controls/Pickers/Picker/types';
import t360IntegrationStore from '~/view/screens/SettingsScreen/store/t360IntegrationStore';
import { ITakerBranch } from '~/types/integrations';
import { localeStore } from '~/mobx/localesStore';
import './style.scss';

interface IProps {
  takerBranch: ITakerBranch;
  selectedToYouBranch: IPickerOption | null;
  toYouBranchOptions: IPickerOption[];
}

const ToYouEnabledPicker: React.FC<IProps> = observer((props: IProps) => {
  const handleSelect = (options: IPickerOption[]) => {
    const selectedBranch = options.length > 0 ? options[0].value : null;
    t360IntegrationStore.updateBranchMapping(props.takerBranch.id, selectedBranch);
  };

  return (
    <Picker
      placeholder={localeStore.t('select_branch')}
      type={PickerType.STATIC}
      selectedOptions={props.selectedToYouBranch ? [props.selectedToYouBranch] : []}
      options={props.toYouBranchOptions}
      onSelect={handleSelect}
      isMulti={false}
      searchable
      position="portal"
      listClassName="break-word"
      maxListWidth={460}
    />
  );
});

export default ToYouEnabledPicker;
